<template>
  <div class="coupon_content"
       :style="{top:(margintop?margintop:0)+50+'px'}">
    <div class="coupon_detail">
      <div class="coupon_1_flex">
        <img class="coupon_detail_image"
               :src='questionData.HeaderImgPath' />
        <span class="coupon_detail_text1">{{questionData.CFHName}}</span>
      </div>
      <div class="coupon_2_flex">
        <span class="coupon_detail_text2">{{questionData.FaceValue}}</span>
        <span class="coupon_detail_text2_little">元</span>
      </div>
      <div class="coupon_detail_text3">
        <span class="coupon_detail_text3">{{questionData.UseMsg}}</span>
      </div>
    </div>
    <div class="coupon_line"></div>
    <div class="coupon_subdetail_content"
         ref="animateref"
         :style="{width:questionWidth}">
      <div class="coupon_subdetail"
           v-if="redPocketIsGet == false" id="Subdetail">
        <div class="coupon_subdetail_text_content">
          <div class="coupon_subdetail_text_flex">
            <span class="coupon_subdetail_text1">适用产品: </span>
            <span class="coupon_subdetail_text2">{{questionData.ApplicableProduct}}</span>
          </div>
          <div class="coupon_subdetail_text_flex">
            <span class="coupon_subdetail_text1">有效期至: </span>
            <span class="coupon_subdetail_text2">{{questionData.ValidEndTime}}</span>
          </div>
          <div class="coupon_subdetail_text_flex">
            <span class="coupon_subdetail_text1">卡券来源: </span>
            <span class="coupon_subdetail_text2">{{questionData.Source}}</span>
          </div>
        </div>
        <div class="action-view">
          <span class="click_btn"
              @click="answerQuestion(0)">答题领红包</span>
          <span class="use_tip"
              @click="useTip">使用须知</span>
        </div>
      </div>
      <div v-for="(item,index) in questionData.LCSubjectList"
           :key="index">
        <div class="coupon_subdetail"
             v-if="redPocketIsGet == false">
          <span class="question_content">{{item.LCSubject}}</span>
          <div class="question_option_content"
               @click="answerQuestionOption(index,0)">
            <span class="question_option"
                  :style="{backgroundColor:firstBtnClick == true ?
                  item.OptionAnswer == 0 ?
                  '#FFFFFF' : '#FFE0BD' :'#FFFFFF',borderColor:firstBtnClick == true ?
                  item.OptionAnswer == 0 ?
                  '#7ED321' : '#FF4400' :'#FF4400',color:firstBtnClick == true ?
                  item.OptionAnswer == 0 ? '#7ED321' : '#FF4400' :'#FF4400'}"
                  >{{item.Option[0]}}</span>
            <img v-if="item.OptionAnswer == 0 ? clickSuccess : clickError"
                   class="question_option_image"
                   :src="item.OptionAnswer == 0 ? 'https://j5.dfcfw.com/image/201812/20181228140939.png':'https://j5.dfcfw.com/image/201812/20181228140958.png'" />
          </div>
          <div class="question_option_content"
               @click="answerQuestionOption(index,1)">:
            <span class="question_option"
                  :style="{backgroundColor:secondBtnClick == true ?
                  item.OptionAnswer == 1 ?
                  '#FFFFFF' : '#FFE0BD' :'#FFFFFF',borderColor:secondBtnClick == true ?
                  item.OptionAnswer == 1 ?
                  '#7ED321' : '#FF4400' :'#FF4400',color:secondBtnClick == true ?
                  item.OptionAnswer == 1 ? '#7ED321' : '#FF4400' :'#FF4400'}"
                  >{{item.Option[1]}}</span>
            <img v-if="item.OptionAnswer == 1 ? clickSuccess : clickError"
                   class="question_option_image"
                   :src="item.OptionAnswer == 1 ? 'https://j5.dfcfw.com/image/201812/20181228140939.png':'https://j5.dfcfw.com/image/201812/20181228140958.png'" />
          </div>
          <span v-if="clickError"
                class="question_option_tip">手滑选错了,重选试试。</span>
        </div>
      </div>
      <div class="coupon_subdetail">
        <div class="coupon_subdetail_text_content">
          <div class="coupon_subdetail_text_flex">
            <span class="coupon_subdetail_text1">适用产品: </span>
            <span class="coupon_subdetail_text2">{{questionData.ApplicableProduct}}</span>
          </div>
          <div class="coupon_subdetail_text_flex">
            <span class="coupon_subdetail_text1">有效期至: </span>
            <span class="coupon_subdetail_text2">{{questionData.ValidEndTime}}</span>
          </div>
          <div class="coupon_subdetail_text_flex">
            <span class="coupon_subdetail_text1">卡券来源: </span>
            <span class="coupon_subdetail_text2">{{questionData.Source}}</span>
          </div>
        </div>
        <div class="bott_view">
          <span class="click_use_btn" :style="{'text-align':'center'}"
              @click="useRedPocket">立即使用</span>
          <span class="use_tip"
              @click="useTip">使用须知</span>
        </div>
      </div>
    </div>
    <div class="close_btn_content"
         @click="closeCoupon">
      <img class="close_btn"
             src='https://j5.dfcfw.com/image/201812/20181228101002.png' />
    </div>
    <img v-if="getRedPocketSuccess==true"
           class="getpocket_success"
           src="https://j5.dfcfw.com/image/201902/20190201102815.png" />
  </div>
</template>

<script>
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  props: ['questionData', 'margintop'],
  data() {
    return {
      currentIndex: 0,
      clickSuccess: false,
      clickError: false,
      firstBtnClick: false,
      secondBtnClick: false,
      getRedPocketSuccess: false,
      questionWidth: '',
      redPocketIsGet: false,
      hasDonePoint: false,
    };
  },
  methods: {
    answerQuestion(questionindex) {
      if (this.hasDonePoint === false) {
        this.hasDonePoint = true;
      }
      const contentEl = this.$refs.animateref;
      const o = document.getElementById('Subdetail');
      const translateStr = `${-o.offsetWidth * (questionindex + 1)}px`;
      contentEl.style.cssText = `width:${this.questionWidth};transform:translateX(${translateStr})`;
    },
    answerQuestionOption(questionindex, option) {
      this.clickSuccess = false;
      this.clickError = false;
      this.currentIndex = questionindex;
      this.firstBtnClick = false;
      this.secondBtnClick = false;

      const currentQuestion = this.questionData.LCSubjectList[questionindex];
      // eslint-disable-next-line no-unused-expressions
      currentQuestion.OptionAnswer === option ? this.clickSuccess = true : this.clickError = true;
      // eslint-disable-next-line no-unused-expressions
      option === 0 ? this.firstBtnClick = true : this.secondBtnClick = true;

      if (currentQuestion.OptionAnswer === option) {
        setTimeout(() => {
          if (questionindex === this.questionData.LCSubjectList.length - 1) {
            // 请求数据,成功后跳到使用
            this.requestGetRedPocket(questionindex);
          } else {
            this.answerQuestion(questionindex + 1);
            this.clickSuccess = false;
            this.clickError = false;
            this.firstBtnClick = false;
            this.secondBtnClick = false;
          }
        }, 500);
      }
    },
    async requestGetRedPocket(currentindex) {
      const currentQuestion = this.questionData;
      this.$feedback.showLoading({ title: '领取中...' });
      await this.$store.dispatch('updateCouponCard', currentQuestion.GifID);
      this.$feedback.hideLoading();
      const resultData = this.$store.state.cfhModules.fund[`${currentQuestion.GifID}CouponCard`];
      if (resultData.Succeed) {
        this.answerQuestion(currentindex + 1);
        this.deleteCoupon();
        this.getRedPocketSuccess = true;
      } else {
        // modal.toast({message: '领取失败...',duration: 1.0})
        this.$feedback.showToast({ title: resultData.ErrMsg, duration: 3000 });
        setTimeout(() => {
          this.closeCoupon();
        }, 2500);
      }
    },
    useRedPocket() {
      this.closeCoupon();
      detailPushPage({
        type: '2',
        url: this.questionData.GiftUseUrl,
      });
    },
    useTip() {
      detailPushPage({
        type: '2',
        url: this.questionData.GiftUseNoticeUrl,
      });
    },
    closeCoupon() {
      this.$emit('closeCouponClick');
    },
    deleteCoupon() {
      this.$emit('deleteCouponClick');
    },
  },
  created() {
    this.questionWidth = `${(this.questionData.LCSubjectList.length + 2) * 580}px`;

    if (this.questionData.UseStatus === false) {
      this.getRedPocketSuccess = true;
      this.redPocketIsGet = true;
    }
  },
};
</script>

<style scoped>
.coupon_content {
  overflow: hidden;
  position: fixed;
  /* top: 100px; */
  left: 85px;
  right: 85px;
  z-index: 99998;
}

.coupon_detail {
  width: 580px;
  height: 266px;
  background: #ffffff;
  border-radius: 5px;
  align-items: center;
  position: relative;
}

.coupon_line {
  border-bottom: 1px dashed #f5f5f5;
  margin-left: 5px;
  margin-right: 5px;
}

.coupon_1_flex {
  display: flex;
  flex-direction: row;
  padding-top: 40px;
  align-items: center;
  justify-content: center;
}

.coupon_detail_image {
  width: 30px;
  height: 30px;
  border-radius: 15px;
}

.coupon_detail_text1 {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  line-height: 32px;
  margin-left: 10px;
}

.coupon_2_flex {
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  align-items: flex-end;

  justify-content: center;
}

.coupon_detail_text2 {
  font-family: PingFangSC-Regular;
  font-size: 80px;
  color: #ff6434;
  line-height: 84px;
}

.coupon_detail_text2_little {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ff6434;
  line-height: 50px;
}

.coupon_detail_text3 {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #666666;
  text-align: center;
  line-height: 32px;
  margin-top: 22px;
  justify-content: center;
}

.coupon_subdetail_content {
  width: 580px;
  height: 428px;
  background: #f5f5f5;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
}

.coupon_subdetail {
  width: 580px;
  height: 428px;
  background: #f5f5f5;
  border-radius: 5px;
}

.coupon_subdetail_text_content {
  margin: 40px;
}

.coupon_subdetail_text_flex {
  display: flex;
  flex-direction: row;
}

.coupon_subdetail_text1 {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  line-height: 44px;
  margin-top: 5px;
}

.coupon_subdetail_text2 {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #000000;
  line-height: 44px;
  margin-top: 5px;
}
.action-view{
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}

.click_btn {
  background: #ff4400;
  border-radius: 6px;
  width: 500px;
  height: 88px;
  line-height: 88px;
  margin-left: 40px;
  margin-right: 40px;
  font-family: PingFangSC-Regular;
  font-size: 34px;
  color: #ffffff;
  text-align: center;
}

.click_use_btn {
  background: #ffffff;
  border: 2px solid #ff4400;
  display: flex;
  border-radius: 6px;
  width: 500px;
  height: 88px;
  line-height: 88px;
  margin-left: 40px;
  margin-right: 40px;
  font-family: PingFangSC-Regular;
  font-size: 34px;
  color: #ff4400;
  text-align: center;
  display: block;
}

.use_tip {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #83a6cf;
  letter-spacing: 0;
  text-align: center;
  line-height: 32px;
  margin-top: 30px;
}

.close_btn_content {
  width: 92px;
  height: 92px;
  margin-top: 64px;
  margin-left: 244px;
  margin-right: 244px;
}

.close_btn {
  width: 92px;
  height: 92px;
}

.question_content {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #000000;
  line-height: 44px;
  justify-content: center;
  margin: 30px 40px 0px 40px;
}

.question_option_content {
  width: 310px;
  height: 60px;
  margin-top: 30px;
  margin-left: 135px;
  margin-right: 135px;
  position: relative;
}

.question_option {
  background: #ffffff;
  border: 2px solid #ff4400;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 34px;
  color: #ff4400;
  text-align: center;
  line-height: 60px;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
}

.question_option_tip {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #ff4400;
  letter-spacing: 0;
  text-align: center;
  line-height: 32px;
  margin-top: 20px;
}

.question_option_image {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 10px;
  right: 10px;
  bottom: 10px;
}

.getpocket_success {
  width: 134px;
  height: 134px;
  position: absolute;
  right: 45px;
  top: 164px;
}
.bott_view{
  flex-direction: column;
  text-align: center;
  justify-content: center;
}
</style>
